import { FunctionalComponent, h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { CheckIcon } from "../../icons/Check";
import { CircleCloseIcon } from "../../icons/CircleClose";
import { CloseIcon } from "../../icons/Close";
import { SnackbarContentStyled } from "./snackbar.style";

export enum SnackbarType {
  Success = 'success',
  Error = 'error',
}

interface SnackbarProps {
  isActive: boolean,
  type: SnackbarType,
  message: string,
  timeout: number,
  callbackOnClose: () => void
  callbackOnClick?: () => void,
}

let timeoutId: any;
export const Snackbar: FunctionalComponent<SnackbarProps> = ({ isActive, type, message, timeout, callbackOnClick, callbackOnClose }) => {
  useEffect(() => {
    if (isActive) {
      timeoutId = setTimeout(() => {
        callbackOnClose();
        clearTimeout(timeoutId);
      }, timeout);
    }
  }, [isActive]);

  const tapCallbackOnClose = () => {
    clearTimeout(timeoutId);
    callbackOnClose();
  };

  return (
    <SnackbarContentStyled isActive={isActive} className={`${type} ${(isActive) ? 'opened' : 'closed'}`}>
      <div>
        <div class="column left">
          {type === SnackbarType.Success && (
            <CheckIcon></CheckIcon>
          )}

          {type === SnackbarType.Error && (
            <CircleCloseIcon></CircleCloseIcon>
          )}
        </div>
        <div class="column center" onClick={callbackOnClick}><p>{message}</p></div>
        <div class="column right" onClick={tapCallbackOnClose}>
          <CloseIcon></CloseIcon>
        </div>
      </div>
    </SnackbarContentStyled>
  )
};